import { Row, Col } from "antd";
import { useEffect, useState } from "react";
import { loadStripe } from "@stripe/stripe-js";

import { SubscriptionCard } from "./SubcriptionCard";
import { useAxiosPrivate } from "../../../../hooks/useAxiosPrivate";
import { useSessionStore } from "../../../../store/session-store";
import { extractPerUnitPrices, LLM_WHISPERER_ENDPOINT } from "../../helper";
import { SpinnerLoader } from "../../../../components/widgets/spinner-loader/SpinnerLoader";
import { useAlertStore } from "../../../../store/alert-store";
import { useExceptionHandler } from "../../../../hooks/useExceptionHandler";
import ServiceLevelsTable from "./ServiceLevelsTable";

const BillingDetails = () => {
  const axiosPrivate = useAxiosPrivate();
  const { sessionDetails } = useSessionStore();
  const { setAlertDetails } = useAlertStore();
  const handleException = useExceptionHandler();

  const [pricing, setPricing] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [stripePromise, setStripePromise] = useState(null);
  const getPlanIds = () => {
    setIsLoading(true);
    const requestOptions = {
      method: "GET",
      url: `${LLM_WHISPERER_ENDPOINT}/pricing/`,
      headers: {
        "X-CSRFToken": sessionDetails?.csrfToken,
      },
    };
    return axiosPrivate(requestOptions)
      .then((res) => {
        const extractedPrices = extractPerUnitPrices(res?.data);
        setPricing(extractedPrices);
      })
      .catch((err) => {
        setAlertDetails(handleException(err, "Failed to get pricing details"));
      })
      .finally(() => setIsLoading(false));
  };

  const cancelSubscription = (productId) => {
    setIsLoading(true);
    const requestOptions = {
      method: "POST",
      url: `${LLM_WHISPERER_ENDPOINT}/subscription/cancel/`,
      headers: {
        "X-CSRFToken": sessionDetails?.csrfToken,
      },
      data: {
        product_id: productId,
      },
    };
    return axiosPrivate(requestOptions)
      .then(() => {
        getPlanIds();
        setAlertDetails({
          type: "success",
          content: "Cancelled successfully ",
        });
      })
      .catch((err) => {
        setAlertDetails(handleException(err));
      })
      .finally(() => setIsLoading(false));
  };

  const loadStripeEnv = () => {
    setIsLoading(true);
    const requestOptions = {
      method: "GET",
      url: `${LLM_WHISPERER_ENDPOINT}/subscription/env/`,
      headers: {
        "X-CSRFToken": sessionDetails?.csrfToken,
      },
    };
    return axiosPrivate(requestOptions)
      .then((res) => {
        setStripePromise(loadStripe(res?.data?.stripe_public_key));
      })
      .catch((err) => {
        setAlertDetails(handleException(err));
      })
      .finally(() => setIsLoading(false));
  };

  useEffect(() => {
    getPlanIds();
    loadStripeEnv();
  }, []);
  return (
    <div className="active-detail-container">
      {isLoading ? (
        <div>
          <SpinnerLoader />
        </div>
      ) : (
        <>
          <Row gutter={[16, 16]} justify={"center"}>
            {pricing
              .sort((a, b) => (a.product === "free" ? -1 : 1))
              .map((plan, index) => {
                // If the Pro plan is subscribed, skip rendering the Free plan
                if (
                  pricing.some((p) => p.product !== "free" && p.isSubscribed) &&
                  plan.product === "free"
                ) {
                  return null;
                }
                const proPlan = pricing.find((plan) => plan.product !== "free");
                if (proPlan) {
                  plan = { ...plan, proPlanProduct: proPlan.product };
                }
                return (
                  <Col key={index} xs={24} xl={24} xxl={12}>
                    <SubscriptionCard
                      cancelSubscription={cancelSubscription}
                      stripePromise={stripePromise}
                      {...plan}
                    />
                  </Col>
                );
              })}
          </Row>
          <ServiceLevelsTable />
        </>
      )}
    </div>
  );
};

export { BillingDetails };
